module.exports = __webpack_public_path__ + "static/media/PalcoNFL.fbe5f77c.mp4";